<template>
  <div class="block">
    <div class="delBtn" @click="showDeleteConfirm">删除</div>
    <a-col :span="6">
      <a-statistic title="姓名" :value="data.name" v-if="data"> </a-statistic>
    </a-col>
    <a-col :span="3">
      <a-statistic title="性别" :value="i18n.t(data.sex)" v-if="data">
      </a-statistic>
    </a-col>
    <a-col :span="10">
      <a-statistic
        :title="i18n.t(data.idType)"
        :value="data.idNumber"
        groupSeparator=""
        v-if="data"
      >
      </a-statistic>
    </a-col>
    <a-col :span="5">
      <a-statistic title="出生日期" :value="data.birthday" v-if="data">
      </a-statistic>
    </a-col>
  </div>

  <div class="head">
    <div class="headLeft">
      <span>报告列表</span>
      <section class="addBtn" @click="showModal">
        <img src="../assets/add.png" alt="" />
        <span>添加</span>
      </section>
      <div class="reply" ref="replayModal">
        <a-modal
          :getContainer="() => $refs.replayModal"
          :title="modalTitle"
          width="50%"
          v-model:visible="modalVisible"
          :confirm-loading="confirmLoading"
          ok-text="确认"
          cancel-text="取消"
          @ok="handleOk"
        >
          <a-form
            ref="ruleForm"
            :model="form"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
          >
            <a-form-item label="收样日期" name="datereceived">
              <a-date-picker
                v-model:value="form.datereceived"
                type="date"
                :format="dateFormat"
                placeholder="请选择收样日期"
                style="width: 100%"
              />
            </a-form-item>
            <a-form-item label="样品编号" name="sampleNo">
              <a-input
                v-model:value="form.sampleNo"
                placeholder="请输入样品编号"
              />
            </a-form-item>
            <a-form-item label="年龄" name="age">
              <a-input-number
                v-model:value="form.age"
                :min="0"
                placeholder="请输入年龄"
                style="width: 100%"
              />
            </a-form-item>
            <a-form-item label="临床诊断" name="diagnosis">
              <a-input
                v-model:value="form.diagnosis"
                placeholder="请输入临床诊断"
              />
            </a-form-item>
            <a-form-item label="报告日期" name="reportDate">
              <a-date-picker
                v-model:value="form.reportDate"
                type="date"
                :format="dateFormat"
                placeholder="请选择报告日期"
                style="width: 100%"
              />
            </a-form-item>
            <a-form-item label="科室" name="departmentName">
              <a-auto-complete
                v-model:value="form.departmentName"
                :dataSource="departmentDataSource"
                placeholder="请输入科室"
                @select="onDepartmentNameSelect"
                @search="onDepartmentNameSearch"
                @change="onDepartmentNameChange"
              />
            </a-form-item>
          </a-form>
        </a-modal>
      </div>
    </div>
    <div style="display: flex">
      <a-input
        class="findInput"
        v-model:value="searchValue"
        allow-clear
        placeholder="请输入临床诊断..."
      />
      <section class="findBtn" @click="onSearch">
        <span>搜索</span>
      </section>
      <section class="findBtn resetBtn" @click="onReset">
        <span>重置</span>
      </section>
    </div>
  </div>
  <div class="tableBlock">
    <!-- :pagination="{
        current: reportParams.page,
        pageSize: reportParams.pageSize,
        total: reportCount,
      }" -->
    <!-- @change="onChange" -->
    <a-table
      :columns="columns"
      :data-source="reportData"
      :rowKey="(record) => record.id"
      v-if="reportData"
      :pagination="false"
    >
      <template v-slot:action="{ record }">
        <span>
          <a @click="viewReport(record)">查看</a>
          <a-divider type="vertical" />
          <a @click="editReport(record)">编辑</a>
        </span>
      </template>
    </a-table>
    <!-- 包裹分页组件即可 -->
    <a-config-provider :locale="locale">
      <a-pagination
        :total="reportCount"
        :show-total="(total) => `共 ${total} 条`"
        :page-size="reportParams.pageSize"
        @change="onChange"
        show-quick-jumper
      />
    </a-config-provider>
  </div>

  <router-view></router-view>
</template>

<script>
import { useI18n } from "vue-i18n";
import { mapActions } from "vuex";
import moment from "moment";
import Analytics from "@/utils/analytics";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { createVNode } from "vue";
import { Modal } from "ant-design-vue";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";

const columns = [
  {
    title: "抽样日期",
    width: "15%",
    dataIndex: "datereceived",
  },
  {
    title: "年龄",
    width: "15%",
    dataIndex: "age",
  },
  {
    title: "临床诊断",
    dataIndex: "diagnosis",
    key: "diagnosis",
  },
  {
    title: "操作",
    width: "15%",
    dataIndex: "action",
    slots: { customRender: "action" },
  },
];

export default {
  setup() {
    const i18n = useI18n();
    return {
      i18n,
    };
  },
  data() {
    return {
      browseStartTime: null,
      data: null,
      reportData: null,
      reportCount: 0,
      reportParams: {
        page: 1,
        pageSize: 5,
        patientIdNumber: "",
        patientName: "",
      },
      departmentDataSource: [],
      departmentData: [],
      departmentCount: 0,
      departmentParams: {
        page: 1,
        pageSize: 7,
        name: "",
        phone: "",
      },
      columns,
      searchValue: "",
      modalTitle: "",
      modalVisible: false,
      confirmLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      dateFormat: "YYYY-MM-DD",
      form: {
        datereceived: "",
        sampleNo: "",
        patientName: "",
        age: "",
        diagnosis: "",
        reportDate: undefined,
        departmentName: "",
      },
      rules: {
        datereceived: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请选择收样日期",
            type: "object",
          },
        ],
        sampleNo: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请输入样品编号",
          },
        ],
        age: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请输入年龄",
            type: "number",
          },
        ],
        diagnosis: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请输入临床诊断",
          },
        ],
        reportDate: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请选择报告日期",
            type: "object",
          },
        ],
        departmentName: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请输入科室",
          },
        ],
      },
      // 汉化包
      locale: zhCN,
    };
  },
  created() {
    this.fetchPatientDetail();
    this.fetchDepartmentList();

    this.browseStartTime = new Date();
  },
  beforeUnmount() {
    Analytics.BrowseEvent(
      this.data.id,
      this.data.name,
      "patient",
      new Date().getSeconds() - this.browseStartTime.getSeconds()
    );
  },
  methods: {
    ...mapActions("patient", ["getPatientDetail", "deletePatient"]),
    ...mapActions("report", [
      "getReportListOfPatient",
      "getReportDetail",
      "createReport",
      "updateReport",
    ]),
    ...mapActions("department", ["getDepartmentList"]),
    async fetchPatientDetail() {
      const data = await this.getPatientDetail(this.$route.params.patientId);
      this.data = data;

      const reportData = await this.getReportListOfPatient(this.data.id);
      this.reportCount = reportData.count;
      this.reportData = reportData.results;
    },
    async fetchReportListOfPatient() {
      const reportData = await this.getReportListOfPatient(this.data.id);
      this.reportCount = reportData.count;
      this.reportData = reportData.results;
    },
    async fetchDepartmentList() {
      const departmentData = await this.getDepartmentList(
        this.departmentParams
      );
      this.departmentcount = departmentData.count;
      this.departmentData = departmentData.results;

      this.departmentDataSource.splice(0, this.departmentDataSource.length);
      this.departmentDataSource = this.departmentData.map(
        (department) => `${department.name} (${department.phone})`
      );
      console.log("this.departmentDataSource: ", this.departmentDataSource);
    },
    viewReport(record) {
      this.$router.push({
        name: "DashboardReport",
        params: { reportId: record.id },
      });
    },
    async editReport(record) {
      const data = await this.getReportDetail(record.id);

      data.datereceived = moment(data.datereceived, this.dateFormat);
      data.patientName = `${data.patient.name} (${data.patient.idNumber})`;
      data.reportDate = moment(data.reportDate, this.dateFormat);
      data.departmentName = `${data.department.name} (${data.department.phone})`;

      this.form = data;

      this.modalTitle = this.form.id ? this.i18n.t("edit") : this.i18n.t("add");
      this.modalVisible = true;

      return data;
    },
    onChange(pageNumber) {
      this.reportParams.page = pageNumber;
      this.fetchReportListOfPatient();
    },
    onSearch() {
      this.reportParams.diagnosis = this.searchValue;
      this.reportParams.page = 1;
      this.fetchReportListOfPatient();
    },
    onReset() {
      delete this.reportParams.diagnosis;

      this.searchValue = "";
      this.reportParams.page = 1;
      this.fetchReportListOfPatient();
    },
    showModal() {
      this.modalTitle = this.form.id ? this.i18n.t("edit") : this.i18n.t("add");
      this.modalVisible = true;
    },
    handleOk() {
      console.log(this.form);

      this.$refs.ruleForm
        .validate()
        .then(async (values) => {
          this.confirmLoading = true;
          console.log("values: ", values);

          // eslint-disable-next-line no-param-reassign
          values.datereceived = values.datereceived.format(this.dateFormat);
          // eslint-disable-next-line no-param-reassign
          values.reportDate = values.reportDate.format(this.dateFormat);
          // eslint-disable-next-line no-param-reassign
          values.patient = this.data.id;
          // eslint-disable-next-line no-param-reassign
          values.department = this.form.department.id;

          console.log("values: ", values);

          if (this.form.id) {
            // eslint-disable-next-line no-param-reassign
            values.id = this.form.id;

            await this.updateReport(values);

            this.$message.success("更新成功");
          } else {
            await this.createReport(values);

            this.$message.success("添加成功");
          }

          this.modalVisible = false;
          this.confirmLoading = false;
          this.fetchReportListOfPatient();
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onDepartmentNameSearch(searchValue) {
      console.log("onDepartmentNameSearch", searchValue);

      const digitReg = /\d/;
      if (digitReg.test(searchValue)) {
        this.departmentParams.phone = searchValue;
        delete this.departmentParams.name;
      } else {
        this.departmentParams.name = searchValue;
        delete this.departmentParams.phone;
      }

      this.departmentParams.page = 1;
      this.fetchDepartmentList();
    },
    onDepartmentNameSelect(value) {
      console.log("onDepartmentNameSelect", value);

      const index = this.departmentDataSource.indexOf(value);
      const department = this.departmentData[index];

      this.form.department = department;
    },
    onDepartmentNameChange(value) {
      console.log("onDepartmentNameChange", value);
    },
    showDeleteConfirm() {
      Modal.confirm({
        title: "真的要删除吗？",
        icon: createVNode(ExclamationCircleOutlined),
        content: this.data.name,
        cancelText: "取消",
        okText: "确定",
        onOk: async () => {
          await this.deletePatient(this.data.id);

          this.$message.success("删除成功");
          this.$router.go(-1);
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.block {
  width: 100%;
  height: 120px;
  background: #ffffff;
  box-shadow: 0px 12px 23px 0px rgba(62, 73, 84, 0.04);
  border-radius: 20px;
  display: flex;
  align-items: center;
  position: relative;
  .ant-col {
    flex: 1;
    display: flex;
    padding-left: 50px;
  }
}

::v-deep .ant-statistic-title {
  color: #999;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
}
::v-deep .ant-statistic-content {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #171b1e;
}

.delBtn {
  position: absolute;
  right: 30px;
  top: 0;
  width: 40px;
  height: 50px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  padding: 9px 6px 23px 6px;
  cursor: pointer;
  background: url("../assets/delBtn.png");
  background-size: 40px 50px;
}
.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 40px;
  .headLeft {
    display: flex;
    align-items: center;
    > span {
      font-size: 28px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #171b1e;
      margin-right: 40px;
    }
  }
}
.addBtn {
  width: 160px;
  height: 58px;
  background: #3a36db;
  border-radius: 29px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 12px;
    margin-right: 8px;
  }
}
.findBtn {
  width: 64px;
  height: 58px;
  border: 1px solid #ff7b31;
  border-radius: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ff7b31;
  line-height: 58px;
  text-align: center;
  cursor: pointer;
  margin-left: 10px;
}
.resetBtn {
  border: 1px solid #666666;
  color: #666666;
}
.findInput {
  width: 300px;
  height: 58px;
  background: #ffffff;
  box-shadow: 0px 0px 23px 0px rgba(62, 73, 84, 0.04);
  border-radius: 15px;
  ::v-deep .ant-input {
    border-radius: 15px;
    width: 300px;
    height: 58px;
    border: 0;
    font-size: 14px;
    font-weight: 400;
    color: #717579;
  }
}
::v-deep .ant-modal .ant-modal-header {
  border-radius: 20px 20px 0 0 !important;
  padding: 30px;
}

::v-deep .ant-modal-content {
  border-radius: 20px;
}
::v-deep .ant-modal-footer {
  padding: 18px 30px;
  .ant-btn {
    width: 106px;
    height: 54px;
    border: 1px solid #3a36db;
    border-radius: 20px 20px 20px 20px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #3a36db;
  }
  .ant-btn-primary {
    background: #3a36db;
    color: #ffffff;
  }
}
::v-deep .ant-modal-title {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #171b1e;
}
::v-deep .ant-modal-close-x {
  line-height: 85px;
}
::v-deep .ant-form label {
  font-size: 16px;
  color: #333;
}
::v-deep .ant-form .ant-input {
  height: 44px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 10px;
}
::v-deep .ant-form .ant-select-selection--single {
  height: 44px;
}
::v-deep .ant-form .ant-select-selection {
  border: 1px solid #eeeeee;
  border-radius: 10px;
}
::v-deep .ant-form .ant-select-selection__rendered {
  line-height: 44px;
}
.tableBlock {
  background: #fff;
  border-radius: 30px;
  overflow: hidden;
  text-align: center;
  ::v-deep .ant-table-thead > tr > th {
    background: #fff;
  }
  ::v-deep .ant-table-row-cell-break-word {
    text-align: center;
  }
  ::v-deep .ant-table-thead tr th,
  ::v-deep .ant-table-tbody tr td {
    text-align: center;
    font-size: 16px;
    color: #333333;
    font-weight: 400;
  }
  ::v-deep .ant-table-tbody tr td a {
    color: #3a36db;
  }
  ::v-deep .ant-table-column-title {
    font-size: 18px;
    font-weight: 500;
  }
  .ant-pagination {
    padding: 20px;
  }
}
</style>
